import React from 'react';
import { Button } from 'antd';

export default class HiddenButton extends React.Component {
  constructor() {
    super();
    this.state = {
      status: false
    };
  }
  
  render() {
    const self = this;
    const { value } = this.props;

    return <div>
    {
      self.state.status === true ?
      <span>{value}</span> :
      <Button style={{ height: '23px' }} type="dashed" onClick={() => {
        self.setState({ status: true });
      }}>点击查看</Button>
    }
  </div>
  }
}